var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6546 2H27.8542V21.8794H48L22.1743 47.705L0 25.5307L1.1787 24.352C3.11238 22.4182 8.79628 16.7342 13.6546 13.3162V2ZM16.9002 5.24561V15.0395L16.1776 15.5213C12.1641 18.197 7.23546 22.9218 4.59276 25.5334L22.1743 43.115L40.1644 25.125H24.6086V5.24561H16.9002Z",
    fill: "#3D3E4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPolygon);
export default __webpack_public_path__ + "static/media/data_polygon.8ab0a79250ec7b6661fa1af11406a68b.svg";
export { ForwardRef as ReactComponent };